import React from 'react';

//import { defaults } from '../utils';
import { forEach, defaultTo, keys } from 'ramda';
import { checkSameProps, defaults /*, objectDiff */ } from '../../utils';

const defaultProperties = ['innerStyle', 'styleFile', 'defaultStyle'];

export default properties => SuperComponent => {
  properties = [...properties, ...defaultProperties];
  return class PropertyManager extends React.Component {
    componentDidCatch(error, info) {
      window.availabilityReactTestingMode && console.error(SuperComponent.displayName, error);
      window.availabilityReactTestingMode && console.error(SuperComponent.displayName, info.componentStack);
    }
    generateProperties = () => {
      this.config = defaults({}, this.props.config);
      forEach(key => {
        this.config[key] = defaultTo(this.props[key])(this.config[key]);
      }, properties || keys(this.props));
      return this.config;
    };
    static displayName = 'PM(' + SuperComponent.displayName + ')';
    // Basicament, si alguna prop no es equal a la nextProp, s'ha de renderitzar again
    shouldComponentUpdate = (nextProps, nextState) => {
      let changed = checkSameProps(this.props, nextProps, properties);
      /*if (window.availabilityReactTestingMode && changed && this.props && nextProps) {
        console.log(SuperComponent.displayName + ' Changes props : ', objectDiff(this.props, nextProps));
      }*/
      return changed;
    };
    render() {
      return React.createElement(
        SuperComponent,
        {
          config: this.generateProperties(),
          content: this.props.content
        },
        this.props.children
      );
    }
  };
};
